import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductCondition } from '@product/const';
import { CustomProductActions, OccProductConditionService } from '@product/data-access';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class ProductConditionsEffects {
  load$: Observable<
    CustomProductActions.LoadProductConditionsSuccess | CustomProductActions.LoadProductConditionsFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomProductActions.LOAD_CONDITIONS),
      mergeMap((action: CustomProductActions.LoadProductConditions) => {
        const { productCode } = action;

        return this.occProductConditionService.loadConditions(productCode).pipe(
          map(
            (conditions: ProductCondition[]) =>
              new CustomProductActions.LoadProductConditionsSuccess(productCode, conditions),
          ),
          catchError((e: unknown) => of(new CustomProductActions.LoadProductConditionsFail(productCode, e))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occProductConditionService: OccProductConditionService,
  ) {}
}
